import { useRouteShellContext } from "@components/routeShellContext"
import { getPath } from "@lib/helper"
import NavMenu from "./NavMenu"
import Title from "./Title"
export function SideMenu() {
  const { locale, pathname } = useRouteShellContext()
  const currentUrl = new URL(pathname, "https://playbrain.com")

  return (
    <aside
      className="fixed top-0 left-0 z-[100] h-[100dvh] w-[var(--side-menu-width)] bg-[var(--deep-blue)]"
      data-id="site-side-menu"
    >
      <Title />
      <nav
        className="relative mt-[50px] min-h-[50px] w-full"
        data-id="site-nav"
      >
        <NavMenu />
        <div
          className="mt-[20px] pt-[10px]"
          data-id="language-switcher"
        >
          <div className={`px-[10%] ${locale === "en" ? "bg-white/10" : ""}`}>
            <p className="m-0 text-[1.5em]">
              <a
                className={`my-[0.5rem] flex items-center justify-center px-[0.5rem] py-[1rem] text-[65%] text-[var(--white)] hover:text-[var(--white)] hover:no-underline hover:transition-none hover:[text-underline-offset:unset] ${
                  locale === "en" ? "bg-white/10" : ""
                }`}
                href={getPath("en", currentUrl)}
                aria-label="ENG"
              >
                ENG
              </a>
            </p>
          </div>
          <div className={`px-[10%] ${locale === "ja" ? "bg-white/10" : ""}`}>
            <p className="m-0 text-[1.5em]">
              <a
                className={`my-[0.5rem] flex items-center justify-center px-[0.5rem] py-[1rem] text-[65%] text-[var(--white)] hover:text-[var(--white)] hover:no-underline hover:transition-none hover:[text-underline-offset:unset] ${
                  locale === "ja" ? "bg-white/10" : ""
                }`}
                href={getPath("ja", currentUrl)}
                aria-label="日本語"
              >
                日本語
              </a>
            </p>
          </div>
        </div>
      </nav>
    </aside>
  )
}

export default SideMenu
